var exports = {
  "uu": "VoiceLobbyShared.module__actionButtons___NFgzLT",
  "hP": "VoiceLobbyShared.module__actionButton___NFgzLT",
  "zc": "VoiceLobbyShared.module__iconContainer___NFgzLT",
  "KA": "VoiceLobbyShared.module__iconContainerBrand___NFgzLT",
  "cF": "VoiceLobbyShared.module__iconContainerDanger___NFgzLT",
  "hO": "VoiceLobbyShared.module__iconContainerTertiary___NFgzLT",
  "cY": "VoiceLobbyShared.module__iconContainerSuccess___NFgzLT",
  "gE": "VoiceLobbyShared.module__actionIcon___NFgzLT",
  "uI": "VoiceLobbyShared.module__actionIconSecondary___NFgzLT",
  "K2": "VoiceLobbyShared.module__actionText___NFgzLT",
  "Hd": "VoiceLobbyShared.module__connectionInfo___NFgzLT",
  "Il": "VoiceLobbyShared.module__connectionHeader___NFgzLT",
  "p1": "VoiceLobbyShared.module__connectionStatusInfo___NFgzLT",
  "bn": "VoiceLobbyShared.module__connectionTitle___NFgzLT",
  "fV": "VoiceLobbyShared.module__connectionSubtitle___NFgzLT",
  "Cb": "VoiceLobbyShared.module__connectionStatusDot___NFgzLT",
  "wL": "VoiceLobbyShared.module__statsGrid___NFgzLT",
  "N8": "VoiceLobbyShared.module__statRow___NFgzLT",
  "Zh": "VoiceLobbyShared.module__statLabel___NFgzLT",
  "cR": "VoiceLobbyShared.module__statValue___NFgzLT",
  "_x": "VoiceLobbyShared.module__statValuePrimary___NFgzLT",
  "V4": "VoiceLobbyShared.module__endpointValue___NFgzLT",
  "TR": "VoiceLobbyShared.module__connectionIdValue___NFgzLT",
  "JX": "VoiceLobbyShared.module__maxWidth___NFgzLT",
};

module.exports = exports;
